// GHS 그림문자(9종) 공용 상수 및 이미지 로더
// GHSWarningLabel.vue / PopupGHSLabelPrint.vue / Print.vue 에서 공통으로 사용한다.
export const GHS_PICTOGRAM_LIST = [
  { key: "GHS01", label: "폭발성" },
  { key: "GHS02", label: "인화성" },
  { key: "GHS03", label: "산화성" },
  { key: "GHS04", label: "고압가스" },
  { key: "GHS05", label: "부식성" },
  { key: "GHS06", label: "급성독성" },
  { key: "GHS07", label: "경고" },
  { key: "GHS08", label: "건강유해성" },
  { key: "GHS09", label: "수생환경유해성" },
];

export function getPictogramImg(key) {
  return require(`@/assets/images/1030/${key}.webp`);
}
